import { format } from 'date-fns/format';
import { SAVED_LIST_COLUMN_IDS } from './constants';
import { SORT_TYPE } from '@app/constants/commonConstants';

export const getFormattedDate = date => {
  const d = new Date(date);
  return format(d, 'MM/dd/yy');
};

export const capitalizeFirstLetter = (text = '') => {
  if (!text) {
    return '';
  }
  return (
    text.toLowerCase().charAt(0).toUpperCase() + text.toLowerCase().slice(1)
  );
};

export const generateSchemaForCSR = baseSchema => {
  const newSchema = structuredClone(baseSchema);
  newSchema.splice(4, 0, {
    id: SAVED_LIST_COLUMN_IDS.EXPIRES,
    label: 'CREDITCARD_EXPIRES_STATE',
    width: '160px',
    behavior: 'sortable',
    sortType: SORT_TYPE.DATE
  });

  return newSchema.filter(column => {
    const itemsToRemove = [
      SAVED_LIST_COLUMN_IDS.ACTIONS,
      SAVED_LIST_COLUMN_IDS.QUANTITY
    ];
    return !itemsToRemove.includes(column.id);
  });
};
